import { FontAwesomeIcon, FontAwesomeLayers } from "@fortawesome/react-fontawesome";
import { InlineImage } from "../../components/InlineImage";
import { faPlane } from "@fortawesome/free-solid-svg-icons";

export default function Day06() {
  return (
    <div className="box light">
      <div className="row">
        <h1>Dag 22 - 1 augustus</h1>
        <h2>
          San José <FontAwesomeIcon icon={faPlane} /> Amsterdam
        </h2>

        <InlineImage width="30%" image="costarica/dag22-01.jpg" webp float="right" />
        <p>
          Vanochtend zijn we wederom vroeg wakker. Maar deze keer blijven we lekker liggen tot iets na zeven uur. Daarna is het tijd voor het ontbijt. Het buffet is prima, met een
          ruime keuze aan allerlei lekkers. Er is zelfs havermoutpap! Na het ontbijt gaan we nog even zwemmen in het buitenbad van het hotel. In San José is het een stuk minder
          warm en benauwd dan aan de kust. Het is hier slechts zo'n 25 graden en bovendien een stuk minder vochtig. Het zwembad voelt daardoor behoorlijk fris aan. Gelukkig is er
          ook een jacuzzi, en die is dan weer superwarm. Zo komen we de laatste ochtend van onze vakantie wel door.
        </p>
        <InlineImage width="20%" image="costarica/dag22-03.jpg" webp float="left" />
        <p>
          Na het zwemmen laten we de auto nog even bij het hotel staan en lopen we in ongeveer een kwartier naar de vlindertuin. We zien hier veel vlinders die we eerder tijdens de
          reis al in het wild hebben gezien, maar nu van dichtbij. En dat maakt het fotograferen een stuk eenvoudiger.
        </p>
        <InlineImage width="20%" image="costarica/dag22-02.jpg" webp float="right" />
        <p>
          Naast de vlindertuin kunnen we nog een stukje door een oud bos lopen. Het is een van de weinige stukjes bos die nog over zijn na de enorme groei van San José. En eerlijk
          gezegd is dit misschien wel het mooiste stukje van de hoofdstad. Een prachtig stukje natuur in een verder niet bepaald mooie stad.
        </p>
        <p>
          Mathijs blijft de hoofdstad overigens steevast San Jose (uitgesproken met een J in plaats van een G) noemen, alsof het om een vrouwennaam gaat. We hebben hem inmiddels zo
          vaak gecorrigeerd dat hij het heeft opgegeven en tegenwoordig gewoon San WC zegt. We eten nog een brownie bij de vlindertuin alssoort van lunch en lopen daarna terug naar
          het hotel om de auto op te halen.
        </p>
        <InlineImage width="25%" image="costarica/dag22-04.jpg" webp float="left" />
        <p>
          Nu zit de vakantie er echt bijna op. We rijden naar de autoverhuur vlak bij het vliegveld en leveren de auto in. Gelukkig blijkt alles helemaal in orde en wordt er geen
          schade aangetroffen. We hadden de auto gehuurd via Adobe Car Rental. Niet de goedkoopste verhuurder, maar wel een betrouwbare. De lekke band hebben we uiteindelijk niet
          meer gedeclareerd. We hadden er geen bonnetje van en het ging tenslotte maar om $6. Voor dat bedrag vonden we het de moeite niet meer om er achteraan te gaan. In de
          koelbox laten we nog wat fooi achter: wat overgebleven kleingeld waar we toch niets meer aan hebben. Daarna stappen we in de shuttlebus die ons naar de vertrekhal brengt.
        </p>
        <InlineImage width="25%" image="costarica/dag22-06.jpg" webp float="left" />
        <p>
          De KLM-vlucht vertrekt om 18.25 uur en brengt ons wederom rechtstreeks naar Schiphol. Deze keer krijgen we vooraf gelukkig geen bericht dat er problemen zijn met het
          entertainmentsysteem. Eenmaal aan boord blijkt inderdaad alles gewoon te werken. We kunnen dus lekker een film kijken en de lange vlucht uitzitten. Bij het opstijgen en
          onderweg krijgen we af en toe nog wat flinke turbulentie. Maar verder verloopt de vlucht prima.
        </p>
      </div>
    </div>
  );
}
